const fr = {
  app: {
    name: "StrongFish",
    tagline: "Application de powerlifting",
  },
  common: {
    cm: "cm",
    retry: "Recharger",
    create: "Créer",
    copy: "Copier",
    copied: "Copié dans le presse-papiers.",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    duplicate: "Dupliquer",
    edit: "Modifier",
    add: "Ajouter",
    close: "Fermer",
    refresh: "Actualiser",
    confirm: "Confirmer",
    search: "Rechercher",
    noResults: "Aucun résultat",
    selectAll: "Tout sélectionner",
    clearSelection: "Effacer",
    selectedOne: "1 sélectionné",
    selectedCount: "{{count}} sélectionnés",
    selectPlaceholder: "Choisir...",
    loading: "Chargement...",
    none: "Aucun",
    yes: "Oui",
    no: "Non",
    back: "Retour",
    actions: "Actions",
    optional: "facultatif",
    unknown: "?",
    kg: "kg",
    all: "Tous",
    open: "Ouvrir",
    logout: "Se déconnecter",
    language: "Langue",
    theme: "Thème",
    light: "Clair",
    dark: "Sombre",
    required: "Obligatoire",
  },
  nav: {
    myPrograms: "Mes programmes",
    strength: "Force",
    find: "Rechercher",
    more: "Plus",
    feed: "Actualités",
    training: "Mon entraînement",
    oneRms: "Mes 1RM",
    healthData: "Données santé",
    clubs: "Clubs",
    exercises: "Exercices",
    profile: "Profil",
    admin: "Administration",
    settings: "Paramètres",
    about: "À propos",
    events: "Calendrier",
    documentation: "Documentation",
    search: "Trouver des personnes",
    messages: "Messages",
    coach: "Coach IA",
    invitations: "Invitations",
    contact: "Contact",
    apiKeys: "Clés d'API",
    downloadApp: "Télécharger l'app Android",
    downloadAppScan: "Scannez ce code avec votre téléphone pour télécharger l'application.",
    collapseSidebar: "Réduire le menu",
    expandSidebar: "Déplier le menu",
  },
  auth: {
    welcomeBack: "Content de vous revoir",
    nameOrUsername: "Indiquez vos nom et prénom, ou choisissez un pseudo : l'un ou l'autre suffit.",
    accountType: "Je suis...",
    imAnAthlete: "Un athlète",
    imAnAthleteHelp: "Vous suivez les programmes écrits par votre coach.",
    imACoach: "Un coach",
    imACoachHelp: "Vous écrivez des programmes et animez des clubs. Un superadmin le confirme d'abord.",
    coachRequestSent:
      "Votre compte coach attend une confirmation. Vous pouvez déjà utiliser StrongFish en tant qu'athlète.",
    scanQr: "Se connecter en scannant un QR code",
    scanQrHelp: "Ouvrez la page des clés d'API sur le site, créez une clé et scannez le QR code affiché.",
    scanFailed: "Ce code ne contient pas de configuration StrongFish.",
    login: "Se connecter",
    signup: "S'inscrire",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    name: "Prénom",
    surname: "Nom",
    forgotPassword: "Mot de passe oublié ?",
    resetPassword: "Réinitialiser le mot de passe",
    newPassword: "Nouveau mot de passe",
    sendResetLink: "M'envoyer un lien",
    resetLinkSent: "Si cet email est enregistré, un lien de réinitialisation a été envoyé.",
    passwordUpdated: "Votre mot de passe a été mis à jour. Vous pouvez vous connecter.",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Vous avez déjà un compte ?",
    orContinueWith: "ou continuer avec",
    confirmed: "Votre compte est confirmé. Vous pouvez vous connecter.",
    confirmFailed: "Ce lien de confirmation est invalide ou a expiré.",
    confirmBanned: "Ce compte a été banni par un administrateur.",
    checkEmail: "Consultez votre boîte mail : nous vous avons envoyé un lien de confirmation.",
    mfaTitle: "Authentification à deux facteurs",
    mfaCode: "Code d'authentification",
    mfaCodeHelp: "Saisissez le code à 6 chiffres de votre application d'authentification.",
    mfaUseKey: "Utiliser ma clé de sécurité",
    mfaVerify: "Vérifier",
    heroTitle: "Des chiffres, pas des approximations.",
    heroSubtitle: "Des programmes en RPE dont les charges suivent votre propre 1RM du moment - écrits par votre coach, recalculés pour vous.",
    photoCreditBy: "Soulevé de terre aux Championnats d'Europe IPF. Photo de",
    accountCreated: "Bienvenue sur StrongFish : votre compte est prêt.",
  },
  profile: {
    measures: "À propos de toi",
    height: "Taille",
    title: "Profil public",
    gender: "Genre",
    genderMale: "Homme",
    genderFemale: "Femme",
    username: "Nom d'utilisateur",
    handleHelp: "Votre profil est partagé sur /profile/{{handle}}",
    anonymous: "Me montrer sous mon nom d'utilisateur",
    anonymousHelp: "Les autres membres voient votre nom d'utilisateur à la place de votre nom, partout : vos publications, vos messages, vos clubs. Votre nom est conservé, simplement masqué.",
    anonymousNeedsUsername: "Choisissez d'abord un nom d'utilisateur : c'est lui que les autres verront à la place du vôtre.",
    bio: "Biographie",
    bodyweight: "Poids de corps",
    visibility: "Qui peut voir mon profil",
    visibilityPublic: "Tout le monde",
    comments: "{{count}} commentaires",
    visibilityClubs: "Mes clubs",
    visibilityPrivate: "Mes coachs uniquement",
    visibilityHelp: {
      public: "Toute personne disposant du lien peut voir votre profil, vos records et vos publications publiques.",
      clubs: "Seules les personnes qui partagent un club avec vous peuvent voir votre profil.",
      private: "Seuls les coachs et administrateurs de vos clubs peuvent voir votre profil.",
    },
    birthdate: "Date de naissance",
    birthdateHelp:
      "Une fois renseignée, les membres de vos clubs qui peuvent voir votre profil retrouvent votre anniversaire dans leur calendrier.",
    notVisible: "Ce profil ne vous est pas visible.",
    bests: "Records",
    total: "Total",
    followers: "Abonnés",
    following: "Abonnements",
    follow: "Suivre",
    unfollow: "Ne plus suivre",
    clubs: "Clubs",
    posts: "Publications",
    noPosts: "Aucune publication.",
    notFound: "Ce profil n'existe pas ou n'est pas public.",
    memberSince: "Membre depuis {{date}}",
    coach: "Coach",
    athlete: "Athlète",
    superadmin: "Superadmin",
    socials: "Où me trouver ailleurs",
    socialsHelp: "Votre compte sur chacun - ou collez l'adresse de votre profil, le nom en sera extrait.",
    rank: "Classement",
    avatar: "Avatar",
    changeAvatar: "Changer d'avatar",
    saved: "Profil enregistré.",
  },
  mfa: {
    title: "Authentification à deux facteurs",
    subtitle: "Protégez votre compte avec un second facteur.",
    totp: "Application d'authentification",
    totpEnabled: "Application d'authentification activée",
    totpDisabled: "Aucune application d'authentification",
    enableTotp: "Activer",
    disableTotp: "Désactiver",
    scanQr:
      "Scannez ce QR code avec votre application d'authentification, puis saisissez le code affiché.",
    manualSecret: "Ou saisissez cette clé manuellement :",
    securityKeys: "Clés de sécurité",
    securityKeysHelp: "Clés USB comme une YubiKey, ou l'authentificateur intégré de votre appareil.",
    addKey: "Ajouter une clé de sécurité",
    keyName: "Nom de la clé",
    noKeys: "Aucune clé de sécurité enregistrée",
    keyAdded: "Clé de sécurité enregistrée.",
    keyRemoved: "Clé de sécurité supprimée.",
    totpConfirmed: "L'authentification à deux facteurs est activée.",
    totpRemoved: "Application d'authentification supprimée.",
    unsupported: "Ce navigateur ne prend pas en charge les clés de sécurité.",
  },
  clubs: {
    title: "Clubs",
    create: "Créer un club",
    edit: "Modifier le club",
    name: "Nom",
    description: "Description",
    city: "Ville",
    country: "Pays",
    logo: "Logo",
    members: "Membres",
    memberCount: "{{count}} membres",
    owner: "Propriétaire",
    admin: "Administrateur",
    member: "Membre",
    role: "Rôle",
    invite: "Inviter quelqu'un",
    inviteHelp:
      "La personne reçoit un e-mail avec un lien. Si elle n'a pas encore de compte, l'invitation l'attend jusqu'à ce qu'elle en crée un avec cette adresse.",
    inviteMessage: "Un mot pour elle",
    sendInvitation: "Envoyer l'invitation",
    invitationSent: "Invitation envoyée.",
    pendingInvitations: "En attente de réponse",
    withdrawInvitation: "Retirer l'invitation",
    addMember: "Ajouter un membre",
    addMemberHelp:
      "Recherchez par email, nom de profil ou nom complet. La personne doit déjà avoir un compte.",
    promote: "Passer administrateur",
    demote: "Passer membre",
    remove: "Retirer du club",
    leave: "Quitter ce club",
    transfer: "Transférer la propriété",
    transferHelp: "Le nouveau propriétaire doit déjà être membre. Vous deviendrez administrateur.",
    empty: "Vous n'êtes membre d'aucun club.",
    emptyCoach: "Créez votre premier club pour commencer à coacher.",
    created: "Club créé.",
    saved: "Club enregistré.",
    deleted: "Club supprimé.",
    memberAdded: "Membre ajouté.",
    memberRemoved: "Membre retiré.",
    confirmDelete:
      "Supprimer le club « {{name}} » ? Ses programmes et publications seront également supprimés.",
    confirmRemove: "Retirer {{name}} du club ?",
    confirmLeave: "Quitter le club « {{name}} » ?",
    feed: "Fil du club",
    feedback: "Retours",
  },
  programs: {
    pickMembers: "Choisir des membres",
    assignCount: "Assigner à {{count}}",
    mine: "Mes programmes",
    mineSubtitle: "Les blocs que vous avez écrits pour vous-même.",
    mineEmptyTitle: "Pas encore de programme personnel",
    mineEmptyBody: "Écrivez-en un, ou copiez un programme d'un de vos clubs pour l'adapter.",
    new: "Nouveau programme",
    exportPdf: "Feuille PDF",
    export: "Exporter",
    exportXlsx: "Tableur Excel (.xlsx)",
    exportPng: "Image à partager (.png)",
    exportWeek: "Exporter cette semaine",
    exportBlock: "Exporter tout le bloc",
    exporting: "Préparation...",
    copy: "Copier",
    copied: "Programme copié",
    move: "Déplacer",
    moved: "Programme déplacé",
    moveInstead: "Le déplacer au lieu de le copier",
    copyHelp: "Une copie a ses propres séances : la modifier ne touche pas à l'original.",
    destination: "Destination",
    moveNeedsElsewhere: "Un déplacement demande une autre destination : le programme est déjà ici.",
    pickDestination: "Choisir un club",
    myLibrary: "Mes propres programmes",
    visibility: "Qui peut le voir",
    visibilityPrivate: "Moi uniquement",
    visibilityPrivateHelp: "Personne d'autre ne peut l'ouvrir.",
    visibilityClubs: "Mes clubs",
    visibilityClubsHelp: "Les personnes avec qui vous vous entraînez peuvent l'ouvrir.",
    visibilityPublic: "Toute personne ayant le lien",
    visibilityPublicHelp: "Partageable en dehors de l'application.",
    importOptional: "Importer un tableur (facultatif)",
    title: "Programmes",
    import: "Importer un tableur",
    importHelp:
      "Envoyez le .xlsx du coach. Deux formats sont reconnus automatiquement : une feuille par semaine, chaque séance commençant par une ligne d'en-tête « Exercice | Reps | RPE | Percentage | Load » ; ou une feuille par bloc, avec un en-tête « EXERCICES | SÉRIES/REPS | RPE » et une colonne W1..Wn par semaine. Les charges calculées dans le fichier sont ignorées : elles sont toujours recalculées à partir des maxima de chaque athlète.",
    importing: "Import en cours...",
    imported: "Programme importé : {{weeks}} semaines, {{days}} séances, {{sets}} séries.",
    createdExercises: "Nouveaux exercices ajoutés au catalogue : {{list}}",
    referenceOneRms: "Ce fichier a été écrit pour ces maxima :",
    useAsMyOneRms: "Utiliser comme mes 1RM",
    warnings: "Remarques sur ce fichier",
    programName: "Nom du programme",
    name: "Nom",
    description: "Description",
    empty: "Aucun programme dans ce club.",
    weeks: "{{count}} semaines",
    sessions: "{{count}} séances",
    setCount: "{{count}} séries",
    author: "Par {{name}}",
    week: "Semaine {{week}}",
    public: "Partagé publiquement",
    private: "Privé",
    publicHelp: "Toute personne disposant du lien peut lire ce programme, sans compte.",
    privateHelp: "Seuls les membres de ce club peuvent lire ce programme.",
    publish: "Partager publiquement",
    unpublish: "Repasser en privé",
    published: "Ce programme est désormais public. Toute personne ayant le lien peut le lire.",
    unpublished: "Ce programme est redevenu privé. Le lien partagé ne fonctionne plus.",
    copyLink: "Copier le lien",
    day: "Jour {{day}}",
    assign: "Assigner",
    assignTo: "Assigner ce programme",
    assigned: "Programme assigné.",
    assignmentsSaved: "Affectations mises à jour.",
    unassign: "Retirer",
    assignments: "Assigné à",
    noAssignments: "Assigné à personne pour l'instant.",
    startDate: "Date de début",
    note: "Note pour l'athlète",
    deleted: "Programme supprimé.",
    confirmDelete:
      "Supprimer le programme « {{name}} » ? Toutes les assignations et séries enregistrées seront perdues.",
    saved: "Programme enregistré.",
    viewAs: "Vu comme",
    myself: "Moi-même",
    create: "Créer un programme",
    createHelp: "Commencez vide puis ajoutez des séances, ou importez le tableur du coach.",
    created: "Programme créé.",
    addSession: "Ajouter une séance",
    editSession: "Modifier la séance",
    sessionSaved: "Séance enregistrée.",
    sessionDeleted: "Séance supprimée.",
    confirmDeleteSession: "Supprimer la semaine {{week}} jour {{day}} et ses séries ?",
    noSessions: "Aucune séance. Ajoutez la première.",
    addSet: "Ajouter une série",
    duplicateSet: "Dupliquer cette série",
    duplicateSession: "Copier cette séance et ses séries sur le même jour de la prochaine semaine libre",
    reorderSession: "Faites glisser pour réordonner cette séance",
    dropSetHere: "Déposer une série ici",
    reorderHelp: "Faites glisser une série par sa poignée pour la réordonner, ou vers une autre séance pour l'y déplacer. Les séances se déplacent de la même façon, par la poignée à côté de leur titre.",
    editSet: "Modifier la série",
    setSaved: "Série enregistrée.",
    setDeleted: "Série supprimée.",
    confirmDeleteSet: "Supprimer cette série ?",
    edit: "Modifier le programme",
    done: "Terminer",
    buildMode: "Modifier le programme",
  },
  session: {
    aiFeedbackAgain: "Une autre analyse",
    aiFeedback: "Analyse de l'IA",
    aiFeedbackHelp: "Demander à l'IA de lire cette séance par rapport aux précédentes.",
    aiFeedbackLocked: "Termine la séance - tous les sets enregistrés - pour demander une analyse.",
    exercise: "Exercice",
    reps: "Reps",
    rpe: "RPE",
    percentage: "%",
    load: "Charge",
    onTheBar: "Sur la barre",
    e1rm: "1RM est.",
    part: "Partie",
    from1rm: "d'après votre 1RM {{lift}} de {{value}}kg",
    fromTodaysE1rm: "d'après les {{value}}kg que vous venez de montrer sur ce mouvement, pas de votre 1RM enregistré",
    perceivedRpe: "Ressenti",
    exportWeek: "Exporter la semaine",
    exportSession: "Exporter cette séance",
    exportBlock: "Exporter le bloc",
    markDone: "Marquer comme faite",
    markUndone: "Marquer comme non faite",
    markDayDone: "Marquer toute la séance comme faite",
    markDayUndone: "Marquer toute la séance comme non faite",
    rpePlaceholder: "RPE",
    autoregulated: "Recalculé d'après ce que vous venez de soulever",
    bodyweight: "Poids de corps",
    beltless: "Sans ceinture",
    beltlessQuestion: "Sans ceinture ?",
    absolute: "Charge fixe",
    missingOneRm: "Saisissez votre 1RM pour voir les charges",
    missingOneRmsList: "Charges manquantes pour : {{list}}",
    setMyOneRms: "Saisir mes 1RM",
    log: "Enregistrer cette série",
    logged: "Série enregistrée.",
    actualReps: "Reps effectuées",
    actualRpe: "RPE ressenti",
    actualLoad: "Charge utilisée",
    loggedLoad: "La charge que vous avez enregistrée pour cette série.",
    loggedLoadPlanned: "La charge que vous avez enregistrée pour cette série. Prévu : {{value}}.",
    loggedReps: "Les répétitions que vous avez enregistrées pour cette série.",
    loggedRepsPlanned: "Les répétitions que vous avez enregistrées pour cette série. Prévu : {{value}}.",
    comment: "Commentaire pour votre coach",
    done: "Fait",
    clearLog: "Effacer",
    yourE1rm: "Votre 1RM estimé pour cette série : {{value}}kg",
    beatsMax: "C'est au-dessus de votre max enregistré.",
    progress: "{{done}} / {{total}} séries effectuées",
    status: "Statut",
    statusActive: "En cours",
    statusDone: "Terminé",
    statusArchived: "Archivé",
    noAssignments: "Aucun programme ne vous a été assigné.",
    noAssignmentsHelp: "Votre coach assigne les programmes depuis votre club.",
    loadMode: "Comment la charge est-elle définie ?",
    loadModeRpe: "Reps à un RPE (d'après le 1RM)",
    loadModePercentage: "Un pourcentage du 1RM",
    loadModeAbsolute: "Une charge fixe",
    loadModeBodyweight: "Poids de corps",
    loadModeHelp: "Une prescription en RPE est résolue avec le max de chaque membre ; un pourcentage lui est appliqué tel qu'il est saisi.",
    absoluteLoad: "Charge",
    notes: "Notes",
    week: "Semaine",
    day: "Jour",
    title: "Titre",
  },
  oneRms: {
    title: "Mes 1RM",
    subtitle:
      "Toutes les charges prescrites en sont calculées. Mettez-en un à jour et tout votre programme est recalculé.",
    lift: "Mouvement",
    value: "1RM",
    updated: "Mis à jour",
    history: "Historique",
    save: "Enregistrer",
    saved: "1RM mis à jour.",
    removed: "1RM supprimé.",
    empty: "Aucun maximum enregistré.",
    addLift: "Ajouter un mouvement",
    mainLifts: "Mouvements de compétition",
    otherLifts: "Autres mouvements",
    confirmDelete: "Supprimer votre 1RM pour {{name}} ?",
  },
  exercises: {
    title: "Catalogue d'exercices",
    subtitle:
      "Partagé par tous les coachs. Ajoutez un mouvement une fois et tout le monde peut le programmer.",
    create: "Ajouter un exercice",
    edit: "Modifier l'exercice",
    name: "Nom",
    labelEn: "Nom (anglais)",
    labelFr: "Nom (français)",
    aliases: "Autres orthographes",
    aliasesHelp:
      "Séparées par des virgules. Les tableurs utilisant ces orthographes s'importeront sur cet exercice.",
    category: "Catégorie",
    categorySquat: "Squat",
    categoryBench: "Développé couché",
    categoryDeadlift: "Soulevé de terre",
    categoryAccessory: "Accessoire",
    oneRmRef: "Charges calculées depuis",
    oneRmRefHelp:
      "Le maximum de compétition auquel une prescription en pourcentage ou en RPE se rapporte.",
    oneRmRefNone: "Aucun maximum (charge fixe)",
    bodyweight: "Chargé au poids de corps",
    created: "Exercice ajouté.",
    saved: "Exercice enregistré.",
    deleted: "Exercice supprimé.",
    confirmDelete: "Supprimer « {{name}} » du catalogue ?",
    empty: "Aucun exercice ne correspond.",
    main: "Mouvement de compétition",
    mainHelp: "Les membres sont invités à saisir un 1RM pour ce mouvement, et les mouvements dérivés y rapportent leurs charges. Réservé au superadmin.",
    adminOnly: "Seul un superadmin peut modifier ou supprimer une entrée du catalogue : elle est partagée par tous les clubs.",
    usageWarning: "Supprimer {{name}} supprimera aussi {{sets}} séries prescrites dans {{programs}} programmes, ainsi que {{oneRms}} 1RM enregistrés. Cette action est irréversible.",
    usageNone: "{{name}} n'est utilisé par aucun programme.",
    checkingUsage: "Vérification de l'impact...",
  },
  feed: {
    title: "Actualités",
    discover: "Découvrir",
    following: "Abonnements",
    compose: "Partagez quelque chose avec votre club...",
    post: "Publier",
    posted: "Publié.",
    visibility: "Visibilité",
    visibilityPublic: "Tout le monde",
    visibilityClub: "Club uniquement",
    pickClub: "Choisir un club",
    pickClubs: "Choisir des clubs",
    addPicture: "Ajouter une image",
    addVideo: "Ajouter une vidéo",
    uploadingVideo: "Envoi de la vidéo... {{percent}} %",
    like: "J'aime",
    liked: "Aimé",
    comment: "Commenter",
    comments: "{{count}} commentaires",
    editedAt: "modifié le {{date}}",
    ownPostLikes: "J'aime sur votre publication. Vous ne pouvez pas aimer la vôtre.",
    writeComment: "Écrire un commentaire...",
    empty: "Rien ici pour l'instant. Suivez quelqu'un ou rejoignez un club.",
    emptyDiscover: "Aucune publication publique.",
    edited: "Modifié",
    report: "Signaler",
    reported: "Signalé. Un modérateur va l'examiner.",
    reportReason: "Pourquoi signalez-vous ce contenu ?",
    reportSpam: "Spam",
    reportAbuse: "Abus ou harcèlement",
    reportInappropriate: "Contenu inapproprié",
    reportOther: "Autre",
    reportComment: "Quelque chose à ajouter ?",
    confirmDeletePost: "Supprimer cette publication ?",
    confirmDeleteComment: "Supprimer ce commentaire ?",
    postDeleted: "Publication supprimée.",
    commentDeleted: "Commentaire supprimé.",
    postUnavailable: "Cette publication n'est pas disponible. Elle a peut-être été supprimée, ou partagée uniquement avec un club.",
    joinToReply: "Rejoignez StrongFish pour aimer cette publication et y répondre.",
    likes: "{{count}} j'aime",
  },
  admin: {
    title: "Administration",
    users: "Utilisateurs",
    clubs: "Clubs",
    reports: "Modération",
    coachRequests: "Demandes de coach",
    searchUsers: "Rechercher un compte",
    makeRole: "Passer en {{role}}",
    ips: "Adresses de connexion",
    ipsTitle: "Connexions de {{name}}",
    ipsHelp:
      "Toutes les adresses depuis lesquelles ce compte s'est connecté, et leur fréquence. Bloquer une adresse relève du pare-feu, pas de cet écran.",
    ip: "Adresse",
    ipCount: "Connexions",
    ipFirstSeen: "Première fois",
    ipLastSeen: "Dernière fois",
    noIpsTitle: "Aucune connexion enregistrée",
    noIpsBody: "Les adresses sont enregistrées lorsque ce compte se connecte.",
    confirmCoach: "Confirmer",
    rejectCoach: "Refuser",
    rejectCoachTitle: "Refuser cette demande de coach ?",
    rejectCoachHelp: "{{name}} recevra votre motif par e-mail : écrivez-le pour cette personne.",
    rejectCoachPlaceholder: "Nous n'avons pas pu vérifier vos qualifications de coach...",
    coachApproved: "Ce compte est désormais coach.",
    coachRejected: "La demande a été refusée et le motif a été transmis.",
    noCoachRequestsTitle: "Aucun coach en attente",
    noCoachRequestsBody: "Lorsqu'une personne s'inscrit comme coach, sa demande apparaît ici.",
    stats: "Vue d'ensemble",
    totalUsers: "Comptes",
    openReports: "Signalements ouverts",
    role: "Rôle",
    roleSuperadmin: "Superadmin",
    roleCoach: "Coach",
    roleConfirmed: "Athlète",
    roleDisabled: "En attente",
    roleBan: "Banni",
    editUser: "Modifier le compte",
    newPassword: "Nouveau mot de passe (laisser vide pour conserver)",
    clearMfa: "Réinitialiser le second facteur",
    clearMfaHelp:
      "Supprime tous les seconds facteurs, pour un utilisateur ayant perdu son téléphone et sa clé.",
    mfaCleared: "Second facteur réinitialisé.",
    userSaved: "Compte enregistré.",
    userDeleted: "Compte supprimé.",
    confirmDeleteUser:
      "Supprimer {{email}} ? Ses clubs, programmes et publications seront supprimés avec.",
    reportStatus: "Statut",
    reportOpen: "Ouvert",
    reportResolved: "Traité",
    reportDismissed: "Rejeté",
    reportedBy: "Signalé par",
    reportTarget: "Contenu",
    resolveAndDelete: "Supprimer le contenu",
    dismiss: "Rejeter",
    resolve: "Traiter",
    resolved: "Signalement traité.",
    noReports: "Rien à modérer.",
  },
  devices: {
    lift: { squat: "Squat", bench: "Développé couché", deadlift: "Soulevé de terre" },
    pair: {
      password: "Mot de passe Stance",
      stance: { email: "Email Stance" },
    },
    record: "Enregistrer une série",
    recordHint: "Ouvre l'app Stance pour suivre une série, puis l'affiche ici.",
    recordFailed: "Impossible d'ouvrir l'app Stance. Est-elle installée ?",
    barSpeed: {
      title: "Vitesse barre - dernière série",
      empty: "Aucune série suivie. Enregistres-en une dans l'app Stance et elle s'affiche ici.",
      load: "{{weight}} kg x {{reps}}",
      rpePair: "RPE {{given}} ressenti, {{real}} mesuré",
      rpeReal: "RPE mesuré {{real}}",
      rep: "Rép {{n}}",
    },
    provider: {
      "google-health": "Google Health (Fitbit, Pixel Watch)",
      withings: "Withings",
      stance: "Stance Fitness",
    },
    aiFeedbackWindow: "sur les {{days}} derniers jours",
    aiFeedback: "Analyse de l'IA",
    aiFeedbackAsk: "Demander à l'IA",
    aiFeedbackAgain: "Redemander",
    aiFeedbackHelp: "Une analyse des 90 derniers jours : activité, fréquence cardiaque et composition corporelle.",
    aiFeedbackEmpty: "Pas encore d'analyse. L'IA peut lire tes 90 derniers jours quand tu veux.",
    title: "Appareils connectés",
    subtitle: "Lisez ce que votre montre et votre balance ont déjà mesuré. Rien n'est écrit en retour, et rien n'est stocké ici.",
    connect: "Connecter",
    connectGoogle: "Se connecter avec Google",
    connectGoogleHint: "Terminez la connexion avec Google dans l'app web.",
    disconnect: "Déconnecter",
    notConnected: "Non connecté.",
    unavailable: "Non activé sur ce serveur.",
    connectedSince: "Connecté depuis le {{date}}.",
    total: "Pas au total",
    dailyAverage: "Moyenne par 24h",
    perDay: "Jour par jour",
    averageBpm: "Fréquence cardiaque moyenne",
    peakBpm: "Fréquence cardiaque maximale",
    noHeartRate: "Aucune fréquence cardiaque enregistrée sur cette période.",
    heartRangeTooWide: "La fréquence cardiaque ne remonte qu'à 14 jours : cette vue plus large n'affiche que les pas. La dernière mesure est ci-dessus.",
    latestBpm: "Dernière fréquence",
    export: "Exporter cette vue",
    bpm: "bpm",
    activityFrom: "Les pas et la fréquence cardiaque affichés viennent de {{provider}}.",
    bodyComposition: {
      title: "Composition corporelle",
      empty: "Aucune mesure de votre balance pour l'instant.",
      takenOn: "Mesuré le {{date}}",
      measure: {
        weight: "Poids",
        bmi: "IMC",
        fatRatio: "Masse grasse (%)",
        fatMass: "Masse grasse",
        fatFreeMass: "Masse maigre",
        muscleMass: "Masse musculaire",
        hydration: "Eau corporelle",
        boneMass: "Masse osseuse",
        visceralFat: "Graisse viscérale",
        basalMetabolicRate: "Métabolisme de base",
      },
    },
    zone: {
      light: "Légère",
      moderate: "Modérée",
      vigorous: "Intense",
      peak: "Maximale",
    },
    range: {
      "24h": "Dernières 24h",
      "48h": "Dernières 48h",
      week: "Dernière semaine",
      "14d": "14 derniers jours",
      month: "Dernier mois",
      "90d": "90 derniers jours",
    },
    outcome: {
      connected: "Compte connecté.",
      denied: "Vous avez refusé la demande, rien n'a été connecté.",
      not_linked: "Ce compte Google n'a pas encore de profil Google Health. Liez votre Fitbit dans l'application Google Health, puis reconnectez-vous.",
      invalid_state: "Ce lien avait expiré. Recommencez.",
      missing_code: "Le fournisseur n'a renvoyé aucune autorisation. Réessayez.",
      unavailable: "Cette intégration n'est pas activée sur ce serveur.",
      exchange_failed: "Le fournisseur a refusé la connexion. Si vous administrez ce serveur, la raison est dans ses logs.",
      account_failed: "Vous êtes authentifié, mais vos données n'ont pas pu être lues. Si vous administrez ce serveur, vérifiez que l'API du fournisseur est activée pour cette application - la raison est dans les logs.",
      store_failed: "La connexion n'a pas pu être enregistrée. Réessayez.",
    },
  },
  errors: {
    invalidHeight: "Saisis une taille en centimètres.",
    aiNotConfigured: "Connecte d'abord un fournisseur d'IA dans tes paramètres.",
    aiRefused: "Ton fournisseur d'IA a refusé la requête. Vérifie la clé, le modèle et ton quota.",
    invalidAiProvider: "Choisis un fournisseur d'IA.",
    invalidAiBaseUrl: "L'adresse doit être une URL http ou https.",
    aiKeyRequired: "Une clé d'API est nécessaire.",
    invalidAiRole: "Ce membre ne peut pas recevoir cet accès.",
    sessionIncomplete: "Termine la séance avant de demander une analyse.",
    conversationTitleRequired: "Donne un titre à cette conversation.",
    nothingSelected: "Choisis d'abord ce qui doit être supprimé.",
    generic: "Une erreur est survenue. Veuillez réessayer.",
    nameOrUsername: "Indiquez des nom et prénom, ou choisissez un pseudo.",
    copyFailed: "Impossible de copier dans le presse-papiers.",
    apiKeyDescription: "Merci d'indiquer à quoi sert cette clé.",
    invalidExpiration: "Merci de saisir une date d'expiration valide.",
    configTokenRequired: "Le jeton de la clé d'API est manquant.",
    storageNotConfigured: "Configurez votre propre stockage vidéo dans les paramètres avant d'envoyer une vidéo.",
    storageUploadFailed: "Votre stockage a refusé cet envoi. Vérifiez le bucket et ses identifiants.",
    storageDownloadFailed: "Ce fichier n'a pas pu être lu depuis le stockage. Il a peut-être été supprimé, ou les identifiants ont changé.",
    videoTooLarge: "Cette vidéo est trop volumineuse.",
    videoTooLargeMax: "Cette vidéo est trop volumineuse. La limite est de {{size}}.",
    unsupportedVideo: "Ce fichier n'est pas une vidéo lisible par un navigateur. Utilisez MP4, WebM ou MOV.",
    invalidStorageType: "Type de stockage inconnu.",
    invalidStorageRole: "Choisissez lecteur ou rédacteur.",
    invalidServiceAccount: "Cette clé de compte de service n'a pas pu être lue.",
    eventTitleRequired: "Merci de donner un titre à cet événement.",
    invalidEventDate: "Merci de vérifier les dates de l'événement.",
    invalidCalendarFile: "Ce fichier n'a pas pu être lu comme un calendrier de saison.",
    invalidBirthdate: "Merci de saisir une date de naissance valide.",
    invalidProfileVisibility: "Visibilité de profil inconnue.",
    invitationNotFound: "Cette invitation n'est plus disponible.",
    alreadyInvited: "Cette personne a déjà été invitée.",
    noCoachRequest: "Ce compte n'a aucune demande de coach en attente.",
    rejectMotiveRequired: "Merci d'indiquer pourquoi cette demande est refusée.",
    cannotMessage: "Vous ne pouvez pas écrire à ce membre.",
    cannotMessageSelf: "Vous ne pouvez pas vous écrire à vous-même.",
    cannotBlockSelf: "Vous ne pouvez pas vous bloquer vous-même.",
    emptyMessage: "Un message ne peut pas être vide.",
    internal: "Une erreur est survenue. Veuillez réessayer.",
    screenTitle: "Cet écran a rencontré un problème",
    screenBody:
      "Un élément de cette page n'a pas pu s'afficher. Le reste de l'application fonctionne toujours : choisissez un autre écran dans le menu, ou rechargez pour réessayer celui-ci.",
    notFound: "Introuvable.",
    invalidRequestBody: "Requête invalide.",
    allFieldsRequired: "Veuillez remplir tous les champs.",
    invalidCredentials: "Email ou mot de passe incorrect.",
    duplicateEmail: "Cet email est déjà utilisé.",
    duplicateHandle: "Ce nom de profil est déjà pris.",
    invalidEmail: "Veuillez saisir une adresse email valide.",
    deviceNotConnected: "Aucun compte n'est encore connecté.",
    deviceNotLinked: "Ce compte n'a pas encore de profil Google Health. Liez votre montre dans l'application Google Health.",
    deviceReauthorize: "La connexion a expiré. Reconnectez le compte.",
    invalidRange: "Cette période n'est pas disponible.",
    deviceUnavailable: "Cette intégration n'est pas activée sur ce serveur.",
    upstream: "Le fournisseur est injoignable. Réessayez dans un instant.",
    invalidHandle: "Ce nom de profil ne peut pas être utilisé.",
    invalidUsername: "Ce nom d'utilisateur ne peut pas être utilisé.",
    duplicateUsername: "Ce nom d'utilisateur est déjà pris.",
    usernameRequired: "Choisissez un nom d'utilisateur pour rester anonyme.",
    userNotFound: "Utilisateur introuvable.",
    noUserWithEmail: "Aucun compte n'est enregistré avec cet email.",
    passwordsMismatch: "Les mots de passe ne correspondent pas.",
    passwordTooShort: "Votre mot de passe doit contenir au moins 8 caractères.",
    passwordNoUpper: "Votre mot de passe doit contenir une majuscule.",
    passwordNoLower: "Votre mot de passe doit contenir une minuscule.",
    passwordNoSymbol: "Votre mot de passe doit contenir un caractère spécial.",
    invalidToken: "Ce lien est invalide ou a expiré.",
    invalidMfaCode: "Code invalide.",
    imageTooLarge: "Cette image est trop volumineuse.",
    invalidRole: "Rôle invalide.",
    cantEditOwnRole: "Vous ne pouvez pas modifier votre propre rôle.",
    cantDeleteOwnAccount: "Vous ne pouvez pas supprimer votre propre compte.",
    nameRequired: "Veuillez saisir un nom.",
    cantRemoveOwner: "Le propriétaire du club ne peut pas être retiré ni rétrogradé.",
    alreadyMember: "Cette personne est déjà dans le club.",
    notAClubMember: "Cette personne n'est pas membre du club.",
    duplicateExercise: "Un exercice portant ce nom existe déjà.",
    exerciseInUse: "Cet exercice est utilisé par un programme et ne peut pas être supprimé.",
    invalidCategory: "Catégorie invalide.",
    invalidOneRm: "Un 1RM doit être supérieur à zéro.",
    invalidSet: "Cette série est incomplète.",
    invalidLoadMode: "Mode de charge invalide.",
    invalidStatus: "Statut invalide.",
    uploadTooLarge: "Ce fichier est trop volumineux.",
    invalidSpreadsheet: "Ce fichier n'a pas pu être lu comme un tableur.",
    noProgramInFile: "Aucun jour d'entraînement n'a été trouvé dans ce tableur.",
    emptyPost: "Une publication doit contenir du texte, une image ou un lien.",
    invalidVisibility: "Visibilité invalide.",
    clubRequired: "Veuillez choisir un club pour une publication réservée au club.",
    cannotLikeOwnPost: "Vous ne pouvez pas aimer votre propre publication.",
    emptyComment: "Un commentaire doit contenir du texte.",
    invalidReportTarget: "Signalement invalide.",
    reportReasonRequired: "Veuillez indiquer pourquoi vous signalez ce contenu.",
    forbidden: "Vous n'êtes pas autorisé à faire cela.",
    accountDisabledAdmin: "Votre compte attend l'activation par un administrateur.",
    accountDisabledEmail: "Veuillez confirmer votre compte avec le lien reçu par email.",
    accountBanned: "Votre compte a été banni par un administrateur.",
    network: "Le serveur est injoignable. Veuillez réessayer.",
    contactFormNotConfigured: "Le formulaire de contact n'est pas disponible sur cette instance.",
    contactFormFailed: "Votre message n'a pas pu être envoyé. Veuillez réessayer plus tard.",
    contactRateLimited: "Vous avez envoyé trop de messages. Veuillez réessayer plus tard.",
    contactMessageTooShort: "Votre message est trop court : donnez-nous un peu plus de détails.",
    contactGibberish: "Votre message a été signalé comme indésirable. Veuillez le reformuler.",
  },
  about: {
    title: "À propos",
    unavailable: "Cette page n'a pas encore été rédigée.",
    openSource: "StrongFish est un produit open source (MIT) de CWCloud. Les sources sont disponibles",
    openSourceLink: "ici",
  },
  apiKeys: {
    title: "Clés d'API",
    openApi: "Référence de l'API",
    intro:
      "Une clé d'API authentifie un script - ou cette application sur votre téléphone - avec un en-tête X-Api-Key plutôt qu'un mot de passe. Elle porte exactement vos droits : traitez-la comme votre mot de passe.",
    create: "Créer une clé",
    description: "À quoi sert-elle ?",
    descriptionPlaceholder: "Mon téléphone, mon script d'export...",
    expiresAt: "Expire le",
    neverExpires: "N'expire jamais",
    expiresOn: "Expire le {{date}}",
    emptyTitle: "Aucune clé d'API",
    emptyBody:
      "Créez-en une pour vous connecter sur votre téléphone en scannant un QR code, ou pour appeler l'API depuis un script.",
    createdTitle: "Votre nouvelle clé d'API",
    createdWarning:
      "Copiez-la maintenant : seule son empreinte est conservée, c'est donc la seule fois où elle sera affichée.",
    downloadConfig: "Télécharger le fichier de configuration",
    showQr: "Afficher le QR code",
    hideQr: "Masquer le QR code",
    qrHelp: "Scannez ce code dans l'application mobile pour y connecter cet appareil.",
    revoke: "Révoquer",
    revokeTitle: "Révoquer cette clé ?",
    revokeBody: "« {{description}} » cessera de fonctionner immédiatement, partout où elle est utilisée.",
    revoked: "La clé a été révoquée.",
  },
  events: {
    title: "Calendrier",
    subtitle: "Compétitions, séances de club et stages - abonnez-y votre propre agenda.",
    add: "Ajouter un événement",
    edit: "Modifier l'événement",
    eventTitle: "Titre",
    kindLabel: "Type",
    kind: {
      competition: "Compétition",
      training: "Entraînement",
      other: "Autre",
    },
    club: "Club",
    noClub: "Calendrier ouvert (tout le monde)",
    startsAt: "Début",
    endsAt: "Fin",
    location: "Lieu",
    url: "Plus d'informations",
    description: "Détails",
    color: "Couleur",
    allDay: "Toute la journée",
    import: "Importer un calendrier",
    importHelp: "Envoyez le calendrier de la saison de la fédération - le planning annuel en PDF ou le tableur. Ses compétitions sont lues avec leurs dates et leurs disciplines.",
    importing: "Lecture du calendrier…",
    imported: "{{count}} compétitions importées",
    importSkipped: "{{count}} étaient déjà dans votre calendrier",
    importWarnings: "Celles-ci ont été trouvées sans date, à ajouter à la main :",
    lastDay: "Dernier jour",
    visibility: "Qui peut le voir",
    visibilityPublic: "Tout le monde",
    visibilityPrivate: "Moi uniquement",
    visibilityPrivateHelp: "Gardé dans votre propre calendrier. Personne d'autre ne le voit, hormis un administrateur.",
    visibilityClub: "Membres du club uniquement",
    showPast: "Afficher les événements passés",
    calendarLayout: "Calendrier",
    listLayout: "Liste",
    monthView: "Mois",
    weekView: "Semaine",
    today: "Aujourd'hui",
    previous: "Précédent",
    next: "Suivant",
    more: "+{{count}} autres",
    dragHint: "Faites glisser sur une journée pour choisir un début et une fin, ou cliquez une demi-heure.",
    moreInfo: "Plus d'informations",
    emptyTitle: "Rien de prévu",
    emptyBody: "Aucun événement à venir. Un coach peut en ajouter un pour son club.",
    created: "Événement ajouté.",
    updated: "Événement mis à jour.",
    deleted: "Événement supprimé.",
    deleteTitle: "Supprimer cet événement ?",
    deleteBody: "« {{title}} » disparaîtra du calendrier de tout le monde, y compris des agendas déjà abonnés.",
    subscribeTitle: "S'abonner depuis Outlook ou Google Agenda",
    subscribeBody:
      "Ajoutez cette adresse comme abonnement de calendrier : vos événements apparaissent au milieu du reste de votre semaine, mis à jour automatiquement.",
    enableFeed: "Obtenir l'adresse de mon calendrier",
    disableFeed: "Désactiver le flux",
    copyFeed: "Copier l'adresse",
    regenerateFeed: "Générer une nouvelle adresse",
    feedRegenerated: "Une nouvelle adresse a été générée. L'ancienne ne fonctionne plus.",
    feedWarning:
      "Toute personne disposant de cette adresse peut lire votre calendrier : c'est le seul justificatif qui existe. Générez-en une nouvelle si elle a fuité.",
  },
  update: {
    upToDate: "Vous êtes à jour",
    available: "La version {{version}} est disponible",
    help: "Télécharge la nouvelle version et la confie à Android pour l'installer. Vous restez connecté.",
    install: "Mettre à jour",
    downloading: "Téléchargement de la mise à jour...",
    failed: "La mise à jour n'a pas pu être téléchargée ou installée. Veuillez réessayer plus tard.",
  },
  ai: {
    orderHelp: "La première répond quand tu ne choisis pas. Déplace les tiennes pour dire laquelle.",
    first: "répond par défaut",
    moveUp: "Monter",
    moveDown: "Descendre",
    generatedBy: "Généré par {{connection}} le {{date}}",
    deleteFeedback: "Supprimer cette analyse",
    deleteFeedbackConfirm: "Supprimer cette analyse ? Elle ne revient pas - il faudrait en redemander une.",
    deleteConversationConfirm: "Supprimer cette conversation ? Tout son contenu part avec.",
    connection: "Connexion IA",
    askWith: "Demander avec",
    modelHelp: "Choisis un modèle de ton fournisseur, ou saisis n'importe quel nom qu'il propose.",
    defaultConnection: "Par défaut",
    title: "Connexions IA",
    subtitle:
      "Connecte un modèle pour lui poser des questions sur ton entraînement. C'est ton compte et ta clé - et tu peux la prêter à d'autres membres, comme un stockage.",
    noConnections: "Aucune IA connectée pour l'instant.",
    addConnection: "Ajouter une connexion",
    name: "Nom",
    namePlaceholder: "Ma clé {{provider}}",
    providerLabel: "Fournisseur",
    baseUrl: "Adresse",
    baseUrlHelp:
      "Où partent les requêtes. Change-la pour viser ta propre passerelle : un LiteLLM, un Ollama, un compte OpenRouter.",
    model: "Modèle",
    token: "Clé d'API",
    tokenSet: "Une clé est déjà enregistrée",
    tokenHelp: "La clé de ton fournisseur. Elle reste sur le serveur et n'est jamais renvoyée au navigateur.",
    tokenKeep: "Laisse vide pour conserver la clé déjà enregistrée.",
    saved: "Connexion enregistrée.",
    cleared: "Connexion supprimée.",
    clear: "Supprimer cette connexion",
    shares: "Qui peut l'utiliser",
    sharesHelp:
      "Prête ta connexion à d'autres membres : ils peuvent poser des questions avec, et rien d'autre. Ils ne voient jamais la clé.",
    noShares: "Personne d'autre n'utilise cette connexion.",
    shareWith: "Membres",
    pickMembers: "Choisir des membres",
    shareAction: "Partager",
    shared: "Connexion partagée.",
    unshare: "Arrêter le partage",
    role: { user: "Peut demander" },
    sharedBy: "partagée par {{name}}",
    coachTitle: "Coach IA",
    coachSubtitle:
      "Pose tes questions sur ton entraînement. Les réponses viennent de ta propre connexion IA, et chaque conversation est conservée ici.",
    connectOne: "En connecter une",
    newConversation: "Nouvelle conversation",
    noConversations: "Aucune conversation pour l'instant.",
    exchangeCount: "{{count}} échanges",
    exchangeOne: "1 échange",
    sharedBadge: "partagée",
    pickConversation: "Sélectionner cette conversation",
    deletePicked: "Supprimer ({{count}})",
    clearAll: "Tout supprimer",
    clearAllConfirm: "Supprimer toutes les conversations ? C'est définitif.",
    deletedCount: "{{count}} conversations supprimées.",
    rename: "Renommer",
    shareLink: "Partager un lien",
    unshareLink: "Arrêter de partager le lien",
    shareLinkHelp: "Toute personne ayant ce lien peut lire la conversation. Reclique sur le lien pour le révoquer.",
    exportConversation: "Exporter la conversation",
    emptyTitle: "Pose ta question",
    emptyBody: "Programmation, technique, récupération, jour de compétition - demande ce que tu veux sur ta pratique.",
    thinking: "Réflexion...",
    placeholder: "Pose une question...",
    send: "Envoyer",
    sharedSubtitle: "Une conversation partagée depuis StrongFish.",
  },
  storage: {
    clearConfirm: "Supprimer ce stockage ? Les fichiers déjà déposés restent où ils sont, mais l'application ne pourra plus les lire.",
    serviceAccountPaste: "Colle le contenu du fichier de clé JSON.",
    noTargets: "Aucun stockage configuré.",
    addTarget: "Ajouter un stockage",
    orderHelp: "Un envoi est déposé dans chaque destination. Le lien de la publication vient de la première.",
    first: "le lien vient d'ici",
    moveUp: "Monter",
    moveDown: "Descendre",
    private: "Ce bucket n'est pas public",
    privateHelp:
      "Activez ceci si votre bucket refuse les fichiers publics : rien n\u2019est rendu public à l\u2019écriture. Dans tous les cas, les fichiers d\u2019un bucket sont toujours servis par StrongFish lui-même, avec vos identifiants, aux personnes qui voient votre profil - et à celles avec qui vous partagez le stockage. Un dossier Google Drive fonctionne autrement : ses fichiers sont publiés sous forme de liens Drive, accessibles à quiconque les possède.",
    shares: "Qui peut l'utiliser",
    sharesHelp:
      "Prêtez votre stockage à d'autres membres : un lecteur peut lire ce qui s'y trouve, un rédacteur peut aussi y déposer des fichiers. Vos propres envois vont toujours d'abord dans votre stockage.",
    noShares: "Personne d'autre n'utilise ce stockage.",
    shareWith: "Membres",
    pickMembers: "Choisir des membres",
    roleLabel: "Ils peuvent",
    role: {
      owner: "Propriétaire",
      writer: "Déposer et lire",
      reader: "Lire",
    },
    shareAction: "Partager",
    shared: "Stockage partagé.",
    unshare: "Ne plus partager",
    title: "Stockage des vidéos",
    subtitle:
      "StrongFish n'héberge aucune vidéo : pour en publier une, utilisez votre propre stockage. Jusqu'à {{size}} Mo par vidéo.",
    type: "Où les stocker",
    typeS3: "Bucket compatible S3",
    typeDrive: "Dossier Google Drive",
    endpoint: "Endpoint",
    region: "Région",
    bucket: "Bucket",
    accessKey: "Clé d'accès",
    secretKey: "Clé secrète",
    publicBaseUrl: "Adresse publique",
    publicBaseUrlHelp: "À renseigner si le bucket est servi par un CDN ou par un domaine à vous.",
    folderId: "Identifiant du dossier",
    serviceAccount: "Clé du compte de service",
    serviceAccountHelp:
      "Le fichier JSON fourni par Google. Partagez d'abord le dossier Drive avec l'adresse de ce compte, sans quoi il ne pourra rien y écrire.",
    serviceAccountSet: "Une clé est déjà configurée. Choisissez un fichier pour la remplacer.",
    pathHelpS3: "Un préfixe dans le bucket. Laissez vide pour écrire à sa racine.",
    pathHelpDrive:
      "Un sous-dossier dans le dossier Drive, créé s'il n'existe pas encore. Imbriquez-le avec des barres obliques, comme strong-fish/videos. Laissez vide pour écrire directement dans le dossier.",
    serviceAccountReadError: "Ce fichier n'a pas pu être lu. Choisissez la clé JSON fournie par Google.",
    path: "Sous-dossier",
    clear: "Supprimer cette configuration",
    saved: "Stockage enregistré.",
    cleared: "Configuration de stockage supprimée.",
  },
  messages: {
    title: "Messages",
    current: "Conversations",
    findSomeone: "Trouver quelqu'un",
    record: "Enregistrer un message vocal",
    stopRecording: "Arrêter l'enregistrement",
    recordingUnsupported: "Ce navigateur ne peut pas enregistrer d'audio.",
    microphoneDenied: "L'accès au microphone a été refusé.",
    subtitle: "Conversations privées avec les membres que vous pouvez voir.",
    message: "Envoyer un message",
    send: "Envoyer",
    placeholder: "Écrivez un message...",
    emptyTitle: "Aucune conversation",
    emptyBody: "Ouvrez le profil d'une personne et écrivez-lui pour en démarrer une.",
    pickTitle: "Choisissez une conversation",
    pickBody: "Sélectionnez quelqu'un à gauche, ou démarrez depuis son profil.",
    threadEmpty: "Aucun message pour l'instant. Dites bonjour.",
    report: "Signaler ce message",
    reportTitle: "Signaler ce message",
    reportHelp:
      "Les modérateurs ne peuvent pas lire votre conversation : le message est donc joint à votre signalement.",
    reportPlaceholder: "Qu'est-ce qui pose problème dans ce message ?",
    reported: "Signalé. Un modérateur va l'examiner.",
    deleteTitle: "Supprimer ce message ?",
    deleteBody: "Il est retiré pour vous deux, et ne peut pas être récupéré.",
    deleted: "Message supprimé",
  },
  blocks: {
    title: "Membres bloqués",
    subtitle:
      "Les personnes bloquées ne peuvent plus vous écrire et leurs publications disparaissent de votre fil.",
    block: "Bloquer",
    blockTitle: "Bloquer ce membre ?",
    blockBody:
      "{{name}} ne pourra plus vous écrire et ses publications disparaîtront de votre fil. Vous pouvez revenir en arrière à tout moment.",
    blocked: "Membre bloqué.",
    unblock: "Débloquer",
    unblocked: "Membre débloqué.",
    since: "Bloqué le {{date}}",
    emptyTitle: "Aucun membre bloqué",
    emptyBody: "Les membres que vous bloquez apparaissent ici, pour pouvoir les réautoriser.",
  },
  share: {
    label: "Partager",
    on: "Partager sur {{network}}",
    copyLink: "Copier le lien",
    profileText: "{{name}} sur StrongFish",
    postText: "Vu sur StrongFish",
  },
  search: {
    title: "Trouver des personnes",
    subtitle:
      "Recherchez par nom, prénom ou e-mail. Vous ne voyez que les profils dont les propriétaires vous y autorisent.",
    terms: "Recherche",
    termsPlaceholder: "Un nom, un nom d'utilisateur, un identifiant, un e-mail...",
    submit: "Rechercher",
    advanced: "Recherche par champ",
    simple: "Recherche simple",
    clear: "Effacer",
    results: "{{count}} personnes trouvées",
    sharesClub: "Dans l'un de vos clubs",
    openProfile: "Ouvrir le profil",
    startTitle: "Qui cherchez-vous ?",
    startBody: "Saisissez un nom, un identifiant ou une adresse e-mail ci-dessus.",
    noneTitle: "Personne trouvée",
    noneBody: "Personne ne correspond - ou son profil ne vous est pas visible.",
  },
  invitations: {
    title: "Invitations",
    subtitle: "Les clubs qui vous ont proposé de les rejoindre.",
    emptyTitle: "Aucune invitation",
    emptyBody: "Lorsqu'un coach vous invite dans son club, elle apparaît ici.",
    from: "Invitation de {{name}}",
    asRole: {
      member: "Vous rejoindriez le club en tant que membre.",
      admin: "Vous rejoindriez le club en tant qu'administrateur.",
    },
    accept: "Accepter",
    decline: "Refuser",
    accepted: "Vous avez rejoint {{club}}.",
    declined: "Invitation refusée.",
  },
  publicProgram: {
    notFoundTitle: "Ce programme n'est pas disponible",
    notFoundBody: "Il a peut-être été repassé en privé, ou le lien est erroné.",
    loadsNotice:
      "Voici la prescription telle qu'elle a été écrite : séries, répétitions et effort. Les charges se calculent à partir des maxima de chaque athlète : connectez-vous pour le suivre avec les vôtres.",
  },
  cookieBanner: {
    title: "Avis relatif aux cookies",
    message: "StrongFish est un produit open-source (MIT). Les cookies et le stockage local qu'il utilise sont nécessaires uniquement au fonctionnement de l'application (connexion, thème et langue) - jamais pour le suivi ou l'analyse.",
    understand: "J'ai compris",
  },
  contact: {
    title: "Nous contacter",
    body: "Une question, un bug ou un retour sur l'application ? Envoyez-nous un message.",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer le message",
    sent: "Votre message a bien été envoyé. Merci !",
  },
  strength: {
    title: "Calculateur de force",
    subtitle: "Ce que vaut un total, sur les trois coefficients du sport.",
    unit: "Unités",
    kg: "kg",
    lb: "lb",
    unitHelp: "Saisissez chaque poids dans l'unité choisie. Les scores sont les mêmes.",
    division: "Catégorie",
    raw: "Sans équipement",
    equipped: "Avec équipement",
    bodyweight: "Poids de corps",
    squat: "Squat",
    bench: "Développé couché",
    deadlift: "Soulevé de terre",
    total: "Total",
    dots: "DOTS",
    wilks: "Wilks (1994)",
    ipfGl: "Points IPF GL",
    enterLifts: "Saisissez un poids de corps et au moins un mouvement pour voir les scores.",
    tierFrom: "{{value}} DOTS",
    percentile: "Devant {{value}}% des {{sample}} pratiquants d'ici ayant enregistré les trois mouvements.",
    strongerThan: "Plus fort que",
    noPopulation: "Personne ici n'a encore enregistré les trois mouvements : rien à quoi se comparer.",
    noBadges: "Aucun badge pour l'instant. Enregistrez vos trois maxs pour commencer.",
    tiers: {
      novice: "Recrue de fonte",
      intermediate: "Prétendant du plateau",
      advanced: "Niveau national",
      elite: "Maître de la barre",
      worldClass: "Titan",
    },
    badges: {
      multiplier: {
        squat2x: "Squat à 2x le poids de corps",
        bench1_5x: "Développé à 1,5x le poids de corps",
        deadlift2_5x: "Soulevé à 2,5x le poids de corps",
        total10x: "Total à 10x le poids de corps",
      },
      club: {
        total1000lb: "Club des 1000 lb",
        total500kg: "Club des 500 kg",
        total1500lb: "Club des 1500 lb",
      },
      dots: {
        300: "Club des 300 DOTS",
        400: "Club des 400 DOTS",
        500: "Club des 500 DOTS",
      },
      style: {
        squatDominant: "Spécialiste du squat",
        deadliftDominant: "Spécialiste du soulevé de terre",
      },
    },
  },
};

export default fr;
